<template>
  <van-notice-bar
    wrapable
    :scrollable="false"
    color="#484848"
    background="#F1F1F1"
    left-icon="records"
  >
    <p class="text3Indentation">
      <strong>汇总时间：数据为每日18:00汇总一次;</strong><br/><strong>转化率：为转到相关科室与体检科绑定的客户占比</strong>
    </p>
  </van-notice-bar>
  <van-grid :column-num="2">
    <van-grid-item icon="home-o" :text="allUserBing"/>
    <van-grid-item icon="points" :text="allUserAi"/>
    <van-grid-item icon="friends-o" text="进入科室:13"/>
    <van-grid-item icon="certificate" text="转化率:36%"/>
  </van-grid>
  <br/>
  <div class="about" id="customerRisk"></div>
  <div class="about" id="customerAge"></div>
</template>
<script>
import { ref, toRefs, reactive, onMounted } from "vue";
import { postGetHospBiPage } from "../../api/doctor";
import * as echarts from "echarts";
export default {
  setup() {
    const active = ref(1);
    const allUserBing = ref('');
    const allUserAi = ref('');
    const allUserKe = ref('');
    const state = reactive({
      userInfo: {
        hospitalName: "",
        area: "",
        realName: "",
        phone: "",
        age: "",
        gender: "",
      },
    });
    const biVo = reactive({
      HospInfoBiVo: {
        hospId: "",
        hospName: "",
        allUser: "",
        allBindUser: "",
        allAiUser: "",
        toKeUser: "",
        ageArr: null,
        riskArr: null,
      },
    });
    const themeVars = reactive({
      fontSizeMd: 32,
    });
    const changAllUserBinging = (data) => {
      allUserBing.value= "总绑定用户:"+data;
    }
    const changAllUserAi = (data) => {
      allUserAi.value= "潜在转化用户:"+data;
    }
    const changUserKe = (data) => {
      allUserKe.value= "转化用户:"+data;
    }
    onMounted(() => {
      postGetHospBiPage().then((res) => {
        console.log(res.data.data);
        biVo.HospInfoBiVo=res.data.data;
        changAllUserBinging(biVo.HospInfoBiVo.allBindUser);
        changAllUserAi(biVo.HospInfoBiVo.allAiUser);
        changUserKe(biVo.HospInfoBiVo.toKeUser);
        customerRiskInit(biVo.HospInfoBiVo.riskArr);
        customerAgeInit(biVo.HospInfoBiVo.ageArr);
      });
    });
    function customerRiskInit(data) {
      var myChart = echarts.init(document.getElementById('customerRisk'), 'walden');
      console.log(data);
      myChart.setOption({
        title: {
                    text: '检测人群风险分布',
                    left: 'center'
                },
                tooltip: {
                    trigger: 'item'
                },
                legend: {
                    top: '5%',
                    left: 'center'
                },
                series: [
                    {
                        name: 'Access From',
                        type: 'pie',
                        radius: '50%',
                        data: data,
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        }
                    }
                ]
      });
    }
    function customerAgeInit(data) {
      var myChart1 = echarts.init(document.getElementById("customerAge"));
      console.log(data);
      myChart1.setOption({
        title: {
                    text: '总体绑定客户分布',
                    left: 'center'
                },
                tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b} : {c} ({d}%)'
                },
                legend: {
                    top: '5%',
                    left: 'center'
                },
                series: [
                    {
                        name: '访问来源',
                        type: 'pie',
                        radius: '55%',
                        center: ['50%', '60%'],
                        roseType: 'radius',
                        data: data,
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        }
                    }
                ]
      });
    }
    return {
      active,
      themeVars,
      biVo,
      allUserBing,
      allUserAi,
      allUserKe,
      changAllUserBinging,
      ...toRefs(state),
    };
  },
};
</script>
<style lang="less" scoped>
/* 去除单元格cell下边框 */
.van-cell:after {
  border-bottom: none !important;
  border-bottom-style: none !important;
}

/* 单元格标题title */
.van-cell .van-cell__title {
  color: #7186e1;
}

/* 标题下方label */
.van-cell .van-cell__label {
  color: #000;
  font-weight: 500;
}

.textIndentation {
  font-size: 12px;
  text-align: left;
}
.text2DIndentation {
  font-size: 14px;
  text-align: left;
  padding-right: 1em;
  padding-left: 1em;
}

.text3Indentation {
    text-align: left;
    font-weight: bold;
    font-size: 14px;
}

#customerRisk {
  height: 600px;
  width: 100%;
}
#customerAge {
  height: 600px;
  width: 100%;
}
</style>
